export default "__VITE_ASSET__Dscq5Xkh__"